import { TableColumn, TableConfig, SORT_ORDER } from "../../../../../@shared/models/table.models";

export const CLAUSE_LIBRARY_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "name",
        header: "Clause name",
        type: "text",
        width: "20%"
    },
    {
        field: "clauseBundles",
        header: "Clause bundle",
        type: "custom",
        template: "clauseBundleTemplate",
        width: "15%"
    },
    {
        field: "source",
        header: "Source",
        type: "custom",
        template: "sourceTemplate",
        width: "15%"
    },
    {
        field: "createdBy",
        header: "Created by",
        type: "custom",
        template: "createdByTemplate",
        width: "15%"
    },
    {
        field: "createdAt",
        header: "Created date",
        type: "custom",
        template: "createdAtTemplate",
        width: "15%"
    },
    {
        field: "usageCount",
        header: "Usage count",
        type: "text",
        width: "10%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "10%"
    }
];

export const CLAUSE_LIBRARY_TABLE_CONFIG: TableConfig = {
    selectable: true,
    selectionOnRowClick: false,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: "calc(100vh - 20rem)",
    loading: false,
    emptyMessage: "No clauses found",
    globalFilter: false,
    responsive: true
};
